import { useState, useEffect } from "react";

export default function Navbar() {
  const [activeNav, setActiveNav] = useState("Home");

  const navItems = [
    "Home",
    "About",
    "Education",
    "Skill",
    "Projects",
    "Contact",
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId.toLowerCase());
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Detect which section is in view as user scrolls
  useEffect(() => {
    const handleScroll = () => {
      const sections = navItems.map((item) =>
        document.getElementById(item.toLowerCase()),
      );

      // Find which section is currently in viewport
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section) {
          const rect = section.getBoundingClientRect();
          // If section is in viewport, set it as active
          if (rect.top <= window.innerHeight / 2) {
            setActiveNav(navItems[i]);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className="fixed top-0 left-0 w-full z-50">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mt-4 flex h-16 items-center justify-between rounded-2xl bg-black/40 backdrop-blur-md border border-white/10 shadow-lg hover:shadow-[0_0_30px_rgba(255,180,80,0.3)] transition-shadow duration-300">
          <h1 className="text-xl font-bold text-transparent bg-clip-text bg-linear-to-r from-orange-400 to-cyan-400 tracking-wider px-4 cursor-pointer hover:scale-105 transition-transform">
            Himanshu
          </h1>

          <div className="flex items-center gap-1 pr-4">
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => {
                  setActiveNav(item);
                  scrollToSection(item);
                }}
                className={`relative px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 group ${
                  activeNav === item
                    ? "text-white"
                    : "text-gray-400 hover:text-white"
                }`}
              >
                {activeNav === item && (
                  <div className="absolute inset-0 bg-white/10 rounded-lg -z-10 animate-pulse" />
                )}
                <span className="relative">{item}</span>
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-linear-to-r from-orange-400 to-cyan-400 group-hover:w-full transition-all duration-300" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
